module.exports = __webpack_public_path__ + "static/media/course_detail_sample.824cd38f.svg";